// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"231":"cdeb3b51","323":"b62cd556","522":"e583e97b","598":"b4aa0768","605":"3e31191a","629":"ff7857d1","673":"0b4fcbf2","694":"55a54c4e","790":"b4a58a64"}[chunkId] + ".chunk.js";
};